export default __webpack_public_path__ + "static/media/mindmap_07.110675c2.png";